import Image from "next/image";
import bnrLevtech from "/public/bnr-levtech.webp";
import bnrLevtechV from "/public/bnr-levtechV.webp";

export const CareersBnrLev = () => {
  return (
    <>
      <a
        href="https://levtech-direct.jp/search?freeWord=%E3%83%88%E3%83%83%E3%82%AB%E3%82%B7%E3%82%B9%E3%83%86%E3%83%A0%E3%82%BA&annualIncome&skillJoin=or&exceptActionedJob"
        target="_blank"
        className="group block"
        rel="noopener noreferrer"
      >
        <div className="mx-auto box-border flex h-[240px] w-full max-w-7xl items-center justify-center border border-solid border-bdc-light group-hover:bg-hov/10 md:h-[300px]">
          <span className="hidden md:block">
            <Image
              src={bnrLevtech}
              alt="ともに成長できる仲間を求めています。「レバテックダイレクト」さまよりご応募いただけます"
              width="883px"
              height="75px"
            />
          </span>
          <span className="block md:hidden">
            <Image
              src={bnrLevtechV}
              alt="ともに成長できる仲間を求めています。「レバテックダイレクト」さまよりご応募いただけます"
              width="227px"
              height="145px"
            />
          </span>
        </div>
      </a>
    </>
  );
};
